import { Link } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import { useSeo } from "@/hooks/useSeo";

export default function NotFound() {
  useSeo({
    title: "善良的小姨子-页面不存在（404）",
    description: "抱歉，你访问的页面不存在。可返回善良的小姨子在线观看首页，继续在线观看剧集或查看剧情与演员信息。",
    keywords: "善良的小姨子,404页面,页面不存在",
  });

  return (
    <SiteLayout>
      <section className="w-full px-4 md:px-8 py-20 md:py-28 flex flex-col items-center text-center">
        <div className="relative">
          <span className="font-heading text-[100px] md:text-[160px] font-black text-primary-100 leading-none">
            404
          </span>
          <span className="absolute inset-0 flex items-center justify-center">
            <span className="w-16 h-16 rounded-full bg-accent-500 text-background-50 flex items-center justify-center">
              <i className="ri-emotion-sad-line text-3xl"></i>
            </span>
          </span>
        </div>
        <h1 className="font-heading text-xl md:text-3xl font-bold text-foreground-950 mt-6">页面走丢了</h1>
        <p className="text-sm md:text-base text-foreground-500 mt-3 max-w-md leading-relaxed">
          抱歉，你访问的页面不存在或已被移除。别担心，回到首页继续追剧吧。
        </p>
        <div className="flex flex-wrap justify-center gap-3 mt-7">
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm md:text-base font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-home-4-line text-lg"></i> 返回首页
          </Link>
          <Link
            to="/play/1"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-background-100 border border-background-300 text-foreground-800 text-sm md:text-base font-medium hover:bg-background-200 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-play-line text-lg"></i> 从第1集开始观看
          </Link>
        </div>
      </section>
    </SiteLayout>
  );
}